<template>
  <div>

    <button class="button is-small addNoteButton" title="Neu" v-on:click="openForm" v-show="!isCreating">
      <i class="fa fa-plus" aria-hidden="true"></i>
    </button>
    
    <div v-show="isCreating">
        <div class='form'>
            <textarea v-model="noteText" type='text'></textarea>
            <button class="button is-small" v-on:click="sendForm()">
              <i class="fa fa-check"></i>
            </button>
            <button class='button is-small' v-on:click="closeForm">
              <i class="fa fa-close"></i>
            </button>
        </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      noteText: '',
      isCreating: false,
    };
  },
  methods: {
    openForm() {
	  	    
      this.isCreating = true;
      
    },
    closeForm() {
      this.isCreating = false;
    },
    sendForm() {
      if ( this.noteText.length > 0) {
        const note = this.noteText;        
        this.$emit('create-note', {
          note,
        });
        this.note = '';
        this.noteText = '';
        this.isCreating = false;
      }
    },
  },
};
</script>